import { useState, useCallback, useEffect } from "react";
import { orderService } from "../services/orderService";
import { authService } from "../services/auth"; // Customer ID için

export const useCustomerOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchOrders = useCallback(async () => {
    const currentUser = authService.getCurrentUser();
    const customerId = currentUser?.id; // Kullanıcı objesindeki ID alanı (varsayım)

    if (!customerId) {
      setError(
        "Siparişleri getirmek için giriş yapılmalı veya kullanıcı ID bulunamadı."
      );
      setOrders([]);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const ordersData = await orderService.getCustomerOrders(customerId);
      console.log("useCustomerOrders - Gelen Orders Data:", ordersData);
      setOrders(ordersData);
    } catch (err) {
      setError(err.message || "Siparişler getirilemedi");
      console.error("Sipariş getirme hatası:", err);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // İlk yüklemede siparişleri getir
  useEffect(() => {
    fetchOrders();
  }, [fetchOrders]);

  return {
    orders,
    loading,
    error,
    refetchOrders: fetchOrders, // Yeniden yükleme için
  };
};

export default useCustomerOrders;
